import { useCallback } from 'react';
import XLSX from 'xlsx-js-style';

export const useFileCreation = () => {
  const createXLSXFile = useCallback(
    (
      data: Record<string, unknown>[],
      sheetName: string,
    ): Uint8Array<ArrayBuffer> => {
      // Create a new workbook and add the worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet([]);

      if (data.length > 0) {
        // Add header row
        const headers = Object.keys(data[0]);
        XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

        // Add data to the worksheet
        XLSX.utils.sheet_add_json(worksheet, data, {
          origin: 'A2',
          skipHeader: true,
        });

        // Set column widths
        const columnWidths = headers.map((header) => ({
          wch: header.length + 30,
        }));
        worksheet['!cols'] = columnWidths;

        const range = XLSX.utils.decode_range(worksheet['!ref'] ?? '');
        const rowCount = range.e.r;
        const columnCount = range.e.c;

        // Add formatting by looping through data in sheet, set wrap text for all cells
        for (let row = 0; row <= rowCount; row++) {
          for (let col = 0; col <= columnCount; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: row, c: col });

            // Add these styles/formats to every cell
            worksheet[cellRef].s = {
              alignment: {
                horizontal: 'left',
                vertical: 'center',
                wrapText: true,
              },
            };

            // Format headers bold
            if (row === 0) {
              worksheet[cellRef].s = {
                ...worksheet[cellRef].s,
                font: { bold: true },
                fill: {
                  fgColor: {
                    rgb: 'CCCCCC',
                  },
                },
              };
            }
          }
        }
      }

      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      // Write the workbook to an array
      const workbookArray = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      return workbookArray;
    },
    [],
  );

  return {
    createXLSXFile,
  };
};
